import loadingStates from "../constants/loadingStates";
import initialState, {
  defaultCourseOffering,
  loadingCourseKey,
  loadingFutureCoursesKey,
  loadingLmsOutlinesKey,
} from "../store/initialState";
import {
  getCurrentRegistration,
  shouldShowAsRegistered,
  sortCoursesByMethodAndDate
} from "../utilities/courseUtilities";

import { selectIsLoggedIn, selectRegisteredCourses } from "./authSelectors";
import { createSelector } from "./createSelector";

const selectDomain = (state) => state.course || initialState.course;

const selectCurrentOfferingId = createSelector(
  selectDomain,
  state => state.currentOffering
);

export const selectCourseOfferingsById = createSelector(
  selectDomain,
  (state) => state.courseOfferingsById
);

export const selectCurrentCourseOffering = createSelector(
  selectCourseOfferingsById,
  selectCurrentOfferingId,
  (courseOfferingsById, uniqueId) => {
    return courseOfferingsById[uniqueId] || defaultCourseOffering;
  }
)

const selectCourseOfferingValues = createSelector(
  selectDomain,
  state => Object.values(state.courseOfferingsById)
)

export const selectCourseOfferings = createSelector(
  selectCourseOfferingValues,
  (courses) => courses.filter((course) => course.id !== 0)
);

export const selectRegisteredCoursesForDisplay = createSelector(
  selectIsLoggedIn,
  selectRegisteredCourses,
  (isLoggedIn, authRegisteredCourses) => {
    if (isLoggedIn) {
      let registeredCourses = authRegisteredCourses
        ? authRegisteredCourses.filter((course) => shouldShowAsRegistered(course))
        : [];

      registeredCourses = sortCoursesByMethodAndDate(registeredCourses, true);

      let registeredCoursesForDisplay = registeredCourses.map(c => {
        return {
          course: c.courseOffering.course,
          courseId: c.courseOffering.course.id,
          courseOfferings: [c.courseOffering]
        };
      });

      return registeredCoursesForDisplay;
    }
    return [];
  }
);

export const selectWasCurrentCoursePreviouslyLoaded = (state) =>
  selectDomain(state).previouslyLoadedCourses[
    selectDomain(state).currentOffering
  ];

export const selectShouldLoadFutureCourses = createSelector(
  selectDomain,
  state => state[loadingFutureCoursesKey] === loadingStates.NOT_LOADED ||
    state[loadingFutureCoursesKey] === loadingStates.FAILED
);

export const selectIsLoadingCourse = createSelector(
  selectDomain,
  (state) => state[loadingCourseKey] === loadingStates.LOADING
);

export const selectIsLoadingLmsOutlines = createSelector(
  selectDomain,
  (state) => state[loadingLmsOutlinesKey] === loadingStates.LOADING
);

export const selectIsLoadingFutureCourses = createSelector(
  selectDomain,
  (state) => state[loadingFutureCoursesKey] === loadingStates.LOADING
);

export const selectCourseRegistration = (state) => {
  const registeredCourses = selectRegisteredCourses(state);
  const courseOffering = selectCurrentCourseOffering(state);

  return registeredCourses
    ? getCurrentRegistration(registeredCourses, courseOffering.uniqueId)
    : false;
};
